import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  SimpleShowLayout,
} from "react-admin";

import GlobalPagination from "../common/GlobalPagination";
import mailForwardFilters from "./mailForwardFilters";

const MailForwardPanel = () => (
  <SimpleShowLayout>
    <TextField source="description" />
  </SimpleShowLayout>
);

const MailForwardList = () => (
  <List
    sort={{ field: "fromEmailAddress", order: "ASC" }}
    filters={mailForwardFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
  >
    <Datagrid rowClick="edit" expand={<MailForwardPanel />}>
      <TextField source="fromEmailAddress" />
      <TextField source="toEmailAddress" />
      <ReferenceField
        source="domainId"
        reference="Domain"
        sortable={false}
        link="show"
      >
        <TextField source="unicodeName" />
      </ReferenceField>
      <ReferenceField
        source="customerId"
        reference="Customer"
        sortable={false}
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
export default MailForwardList;
